import { IBaseEntity } from './common.type';
import { ITenant } from './tenant.type';

export interface IUser extends IBaseEntity {
  username: string;
  tenant: ITenant;
  type: EUserType;
}

export enum EUserType {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
}

export interface IChangePasswordBody {
  oldPassword: string;
  newPassword: string;
}
